module.exports = __webpack_public_path__ + "img/stick_patrimoine_artisanat_art.132f7003.svg";